import { useUnreadsDivergenceDebugger } from "domains/concierge/internal/hooks/useUnreadsDivergenceDebugger";

export const ConciergeUnreadsDivergenceDebuggerInitializer = () => {
    useUnreadsDivergenceDebugger();
    return null;
};
